import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import RoleControlled from '../../_common/RoleControlled'

import { toggleVisibility, showToast } from '../../../actions'
import { URL } from '../../../const'

import FaqItem from './FaqItem'
import Loader from '../../_common/Loader'
import AddFaq from './AddFaq'

export class Faq extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      data: [],
      addingNewFaq: false,
      show_panel: false
    }
  }

  componentDidMount () {
    this._fetchData()
  }
  async _fetchData () {
    this.setState({ loading: true })
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    const url = `${URL}faq/${this.props.propertyID}`

    try {
      const res = await axios.get(
        url,
        config
      )
      const data = res.data.items
      console.log('res, ', res.data)
      this.setState({ data, loading: false, show_panel: res.data.show })
    } catch (error) {
      console.log('An error occured while fetching residents data.')
    }
  }

  _handleAddClick () {
    this.setState({ addingNewFaq: true })
  }
  _handleCancelClick () {
    this.setState({ addingNewFaq: false })
  }
  _handleEnablePanel (e) {
    this.setState({ show_panel: e.target.checked })
    this.props.toggleVisibility(this.props.propertyID, 0, e.target.checked)
  }

  async _handleSaveFaq (data) {
    // console.log('saving data...', data)
    const url = `${URL}faq/${this.props.propertyID}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    try {
      const res = await axios.post(
        url,
        data,
        config
      )
      console.log('post res: ', res)
      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }

  async _handleCreateFaq (data) {
    console.log('saving data...', data)
    const url = `${URL}faq/${this.props.propertyID}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }

    try {
      const res = await axios.post(
        url,
        data,
        config
      )
      console.log('post res: ', res)
      this.props.showToast('保存しました！', 'primary')
      this.setState({ addingNewFaq: false })
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }

  async _handleDeleteFaq (id) {
    const url = `${URL}faq?id=${id}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    try {
      const res = await axios.delete(
        url,
        config
      )
      console.log('post res: ', res)
      this.props.showToast('削除しました。', 'danger')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
    }
  }

  _renderMain () {
    return (
      <div className="inner_container">
        { this._renderAddItem() }
        { this._renderList() }
      </div>
    )
  }

  _renderAddItem () {
    if (this.state.addingNewFaq) {
      return <AddFaq saveData={this._handleCreateFaq.bind(this)} cancel={this._handleCancelClick.bind(this)}/>
    }
    return null
  }

  _renderList () {
    return this.state.data.map(item => {
      return (
        <FaqItem
          faq={item}
          key={item.qa_id}
          role={this.props.user.user_role}
          saveData={this._handleSaveFaq.bind(this)}
          deleteData={this._handleDeleteFaq.bind(this)}
        />
      )
    })
  }
  _renderLoader () {
    if (this.state.loading) {
      return <Loader classname="loader_dot_circle small"/>
    }
    return null
  }
  render () {
    return (
      <div>
        <h4 className="page_title bold flex justify-between">
          <div className="title flex">
            <span>よくある質問一覧</span>
            { this._renderLoader() }
          </div>
          <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
            <div className="switch">
              <input type="checkbox" id="showSwitch" className="switch-input" key="checkbox" onChange={this._handleEnablePanel.bind(this)} checked={this.state.show_panel}/>
              <label htmlFor="showSwitch" className="switch-label" key="label">
                <span className="toggle--on">表示</span>
                <span className="toggle--off">非表示</span>
              </label>
            </div>
          </RoleControlled>
        </h4>
        {
          this.state.show_panel
            ? (
              <div>
                <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
                  <div className="add_btn_container flex">
                    <button className="btn primary small_btn flex align-center" onClick={this._handleAddClick.bind(this)}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-add">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                      </svg>
                      <span>追加</span>
                    </button>
                  </div>
                </RoleControlled>

                <div className="list_container">
                  { this._renderMain() }
                </div>
              </div>
            )
            : null
        }
      </div>
    )
  }
}

function mapStateToProps ({ user }) {
  return { user }
}

export default connect(mapStateToProps, { toggleVisibility, showToast })(Faq)



// WEBPACK FOOTER //
// ./src/components/Properties/Faq/index.js